export const contact = {
  hero: {
    home: 'Home',
    contact: 'Contact',
    getInTouch: 'Get In Touch',
    subtitle: 'Our team of filtration experts is ready to assist you with technical inquiries, project consultations, and support',
  },
  info: {
    talkWithUs: 'Talk with Us',
    einaDescription: 'Your trusted partner in industrial filtration and purification solutions',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    businessHours: 'Business Hours',
    mondayFriday: 'Monday - Friday: 8 AM - 5 PM',
    saturday: 'Saturday: 8 AM - 12 PM',
    sunday: 'Sunday: Closed',
    followUs: 'Follow Us',
    steEinaLtd: 'Ste EINA Ltd',
  },
  form: {
    sendMessage: 'Send Us a Message',
    formDescription: "Fill out the form below and we'll get back to you as soon as possible",
    name: 'Name',
    namePlaceholder: 'Your full name',
    email: 'Email',
    emailPlaceholder: 'your.email@company.com',
    phone: 'Phone',
    phonePlaceholder: '+1 (555) 123-4567',
    subject: 'Subject',
    selectInquiry: 'Select inquiry type',
    technicalInquiry: 'Technical Inquiry',
    productInformation: 'Product Information',
    quotationRequest: 'Quotation Request',
    technicalSupport: 'Technical Support',
    partnership: 'Partnership Opportunities',
    general: 'General Inquiry',
    message: 'Message',
    messagePlaceholder: 'Tell us about your inquiry...',
    charactersCount: '{{count}}/500 characters',
    send: 'Send Message',
    sending: 'Sending...',
    successTitle: 'Message Sent Successfully!',
    successDesc: "We'll get back to you within 24 hours.",
    errorTitle: 'Sending Failed',
    errorDesc: 'Please try again or email us directly.',
  },
  map: {
    ourLocation: 'Our Location',
    locationAddress: 'Echangeur Fokou, Bonaberi, Cameroun',
  },
  quickLinks: {
    needInfo: 'Need Specific Information?',
    quickAccess: 'Quick access to our most requested resources',
    productCatalog: 'Product Catalog',
    catalogDesc: 'Browse our complete range of filtration solutions',
    technicalStudy: 'Technical Study',
    studyDesc: 'Request a detailed technical analysis',
    supportServices: 'Support Services',
    supportDesc: 'Learn about our comprehensive support',
  },
};